import { render, staticRenderFns } from "./DetailProjectPlan.vue?vue&type=template&id=4a285ee6&scoped=true"
import script from "./DetailProjectPlan.vue?vue&type=script&lang=js"
export * from "./DetailProjectPlan.vue?vue&type=script&lang=js"
import style0 from "./DetailProjectPlan.vue?vue&type=style&index=0&id=4a285ee6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a285ee6",
  null
  
)

export default component.exports